export default __webpack_public_path__ + "static/media/advocord_admin.cf70aa19.svg";